// extracted by mini-css-extract-plugin
module.exports = {"root":"Layout_root__F2PTs","body":"Layout_body__15eHz","resetPassword":"Layout_resetPassword__1U3Oz"};